import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { ContactConfigureBottomPanel } from './ContactConfigureBottomPanel.component'

const withUnmountHoc = withUnmountTransition(ContactConfigureBottomPanel)
export { withUnmountHoc as ContactConfigureBottomPanel }
